"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expirationDateFormat = exports.cvcFormat = exports.creditCardFormat = void 0;
const creditCardFormat = (value, classicPattern, cb) => {
    let ccNumString = value;
    ccNumString = ccNumString.replace(/[^0-9]/g, '');
    if (ccNumString.length > 16) {
        ccNumString = ccNumString.slice(0, 16);
    }
    const typeCheck = ccNumString.substring(0, 2);
    let cType = '';
    let formatted;
    if (typeCheck.length === 2) {
        const typeCheckNum = parseInt(typeCheck, 10);
        if (typeCheckNum >= 40 && typeCheckNum <= 49) {
            cType = 'Visa';
        }
        else if (typeCheckNum >= 51 && typeCheckNum <= 55) {
            cType = 'Master Card';
        }
        else if ((typeCheckNum >= 60 && typeCheckNum <= 62) || typeCheckNum === 64 || typeCheckNum === 65) {
            cType = 'Discover';
        }
        else if (typeCheckNum === 34 || typeCheckNum === 37) {
            cType = 'American Express';
        }
        else {
            cType = 'Invalid';
        }
    }
    if (cType === 'Visa' || cType === 'Master Card' || cType === 'Discover' || cType === 'Invalid' || classicPattern) {
        formatted = ccNumString.replace(/(.{4})/g, '$1 ').trim();
    }
    else if (cType === 'American Express') {
        formatted = ccNumString.replace(/(.{4})(.{6})(.{5})/g, '$1 $2 $3');
    }
    else {
        formatted = ccNumString;
    }
    cb === null || cb === void 0 ? void 0 : cb(formatted, cType);
    return { formatted, cType };
};
exports.creditCardFormat = creditCardFormat;
const cvcFormat = (value, cb, maxLength) => {
    const formatted = value
        .replace(/[^0-9]/g, '')
        .substring(0, maxLength || 4)
        .trim();
    cb === null || cb === void 0 ? void 0 : cb(formatted);
    return { formatted };
};
exports.cvcFormat = cvcFormat;
const expirationDateFormat = (value, yearDigits, cb) => {
    const formatted = value
        .replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .substring(0, yearDigits === 4 ? 7 : 5)
        .trim();
    cb === null || cb === void 0 ? void 0 : cb(formatted);
    return { formatted };
};
exports.expirationDateFormat = expirationDateFormat;
